import { styled } from 'styled-components'
import HomePageVideo from 'pages/HomePage/Components/HomePageVideo/HomePageVideo'
import { heroVideoStyles } from '../heroSection.styles'

export const VideoLayer = styled(HomePageVideo)<{
  $hidden?: boolean
}>`
  ${heroVideoStyles}
  display: ${({ $hidden }) => ($hidden ? 'none' : 'block')};
`
